<template>
  <div class="page-content" id="bi-div"></div>
</template>

<script>
import myVuex from './myData'

export default {
  name: 'reportComponent',
  props: {
    codeStr: String
  },
  mixins: [myVuex],
  data () {
    return {
      url: 'https://login.dingtalk.com/oauth2/auth?redirect_uri=http%3A%2F%2F146.56.192.234%2F%23%2Fddsq&response_type=code&client_id=dingoudh6eck3blbpfco&scope=openid&prompt=consent'
    }
  },
  mounted () {
    window.flag = this.goHome
    this.getUrl()
  },
  methods: {
    goHome (data) {
      this.saveLoginData(data)
      setTimeout(() => {
        this.$router.push('/home')
        if (this.form.getFieldValue('password') === '1234qwer') {
          this.$notification.warning({ message: '系统提示', description: '请尽快修改您的初始密码！', duration: 4 })
        }
      }, 500)
    },
    getUrl () {
      var frame = '<iframe frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="100%" height="100%" src="' + this.url + '"></iframe>'
      var newNode = document.createElement('div')
      newNode.innerHTML = frame
      newNode.style.height = '1200px'
      var htmlBody = document.getElementById('bi-div')
      htmlBody.insertBefore(newNode, htmlBody.firstChild)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ddLogin/ddsq.vue